module.exports = __webpack_public_path__ + "img/logo.15747262.svg";